// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RiseHand__rise-hand-container-e9d28c {
  display: flex;
  align-items: center;
}

.RiseHand__rise-hand-icon-ffffbe {
  border-radius: 50%;
  flex: 0 0 auto;
  background-color: var(--addition-50);
  z-index: 2;
}

.RiseHand__avatar-f0760e {
  margin-inline-end: 8px;
  margin-inline-start: -5px;
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/EventsBar/components/RiseHand/RiseHand.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;EACA,oCAAA;EACA,UAAA;AACF;;AAEA;EACE,sBAAA;EACA,yBAAA;EACA,UAAA;AACF","sourcesContent":[".rise-hand-container {\n  display: flex;\n  align-items: center;\n}\n\n.rise-hand-icon {\n  border-radius: 50%;\n  flex: 0 0 auto;\n  background-color: var(--addition-50);\n  z-index: 2;\n}\n\n.avatar {\n  margin-inline-end: 8px;\n  margin-inline-start: -5px;\n  z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rise-hand-container": `RiseHand__rise-hand-container-e9d28c`,
	"riseHandContainer": `RiseHand__rise-hand-container-e9d28c`,
	"rise-hand-icon": `RiseHand__rise-hand-icon-ffffbe`,
	"riseHandIcon": `RiseHand__rise-hand-icon-ffffbe`,
	"avatar": `RiseHand__avatar-f0760e`
};
module.exports = ___CSS_LOADER_EXPORT___;
